module.exports = __webpack_public_path__ + "static/img/calc.e5efbb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/calc.png
// module id = wzSE
// module chunks = 1